import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  // Accordion,
  // AccordionSummary,
  // AccordionDetails,
  // Slider,
  withStyles,
  FormControlLabel,
  Checkbox,
  Hidden,
  useMediaQuery,
  useTheme,
  Divider,
} from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroll-component";
import BodyText from "../../components/reusableComponents/BodyText";
import HeaderSection from "../../components/reusableComponents/HeaderSection";
import { useSelector } from "react-redux";
import Slider from "@mui/material/Slider";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useHistory, useLocation } from "react-router-dom";
import SkeletonOneway from "../../components/reusableComponents/SkeletonOneway";
const International = () => {
  const { flightreturn, loading, orderID } = useSelector((state) => state.home);
  const { selectedOrigin, selectedDepart } = useSelector((state) => state.ui);
  const [value, setValue] = React.useState([1000, 100000]);
  const [scrollVal, SetScrollVal] = useState(10);
  const [data, setData] = useState(false);
  const history = useHistory();
  const [scrollValResult, SetScrollValResult] = useState(10);
  const [hasMoreresult, SethasMoreResult] = useState(true);
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const fetchMoreDataResult = () => {
    if (scrollValResult >= 200) {
      SethasMoreResult(false);
    }
    setTimeout(() => {
      SetScrollValResult(scrollValResult + 5);
    }, 500);
  };
  const location = useLocation();
  console.log("lo", location);
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr and " + rminutes + " min.";
  }
  return (
    <>
      <HeaderSection id={1} />
      {/* <Container> */}
      <Box style={{ padding: 10 }}>
        <Grid container style={{ marginTop: 100 }} spacing={2}>
          <Grid item xs={2}>
            <Box
              style={{ border: "1px solid rgb(38 38 38 / 27%)", padding: 15 }}
            >
              <h4>Filter</h4>
              <Divider />
              <h5>Stop:</h5>
              <Box display={"flex"} alignItems="center">
                <span>Non Stop</span>
                <Box
                  // onClick={() => {
                  //   handleZero();
                  //   stop1 ? setStop1(false) : setStop1(true);
                  //   rule ? SetRule(false) : SetRule(true);
                  // }}
                  style={{
                    width: "40px",
                    padding: "6px 0px",
                    // background: stop1 ? "rgb(239, 51, 57)" : "#eee",
                    // color: stop1 ? "white" : "#666",
                    border: "1px solid #ddd",
                    borderRadius: "2px",
                    fontWeight: 700,
                    textAlign: "center",
                    cursor: "pointer",
                    marginLeft: 20,
                  }}
                >
                  <BodyText textStyle={{ fontSize: 14 }}>0</BodyText>
                </Box>
              </Box>
              <Box display="flex" style={{ marginTop: 20 }} alignItems="center">
                <span>1 Stop</span>
                <Box
                  // onClick={() => {
                  //   handleOne();
                  //   stop2 ? setStop2(false) : setStop2(true);
                  //   rule ? SetRule(false) : SetRule(true);
                  // }}
                  style={{
                    width: "40px",
                    padding: "6px 0px",
                    // background: stop2 ? "rgb(239, 51, 57)" : "#eee",
                    // color: stop2 ? "white" : "#666",
                    border: "1px solid #ddd",
                    borderRadius: "2px",
                    fontWeight: 700,
                    textAlign: "center",
                    cursor: "pointer",
                    marginLeft: 40,
                  }}
                >
                  <BodyText textStyle={{ fontSize: 14 }}>1</BodyText>
                </Box>
              </Box>
              <Box display="flex" style={{ marginTop: 20 }} alignItems="center">
                <span>2+ Stop</span>
                <Box
                  // onClick={() => {
                  //   handleTwo();
                  //   stop3 ? setStop3(false) : setStop3(true);
                  //   rule ? SetRule(false) : SetRule(true);
                  // }}
                  style={{
                    width: "40px",
                    padding: "6px 0px",
                    // background: stop3 ? "rgb(239, 51, 57)" : "#eee",
                    // color: stop3 ? "white" : "#666",
                    border: "1px solid #ddd",
                    borderRadius: "2px",
                    fontWeight: 700,
                    textAlign: "center",
                    cursor: "pointer",
                    marginLeft: 32,
                  }}
                >
                  <BodyText textStyle={{ fontSize: 14 }}>2+</BodyText>
                </Box>
              </Box>
              <Divider style={{ marginTop: 20 }} />
              <h4>Price:</h4>
              <Box>
                <Slider
                  style={{ maxWidth: 500, color: "rgb(239, 51, 57)" }}
                  // value={value}
                  min={1000}
                  max={100000}
                  aria-label="Default"
                  // onChange={handleSlider}
                  valueLabelDisplay="auto"
                  aria-labelledby="non-linear-slider"
                  disableSwap
                />
                <Box display="flex" justifyContent="space-between">
                  <p>Min: {value[0]}</p>
                  <p>Max: {value[1]}</p>
                </Box>
              </Box>
              <Divider style={{ marginTop: 20 }} />
              <h4>Airlines:</h4>
              {/* <Box mt={matches ? "20px" : ""} className={classes.radio}>
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check}
                        onChange={handleCheck}
                        name="SG"
                      />
                    }
                    label="SpiceJet"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check2}
                        onChange={handleCheckGO}
                        name="G8"
                      />
                    }
                    label="GO FIRST"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check3}
                        onChange={handleCheckIndigo}
                        name="6E"
                      />
                    }
                    label="Indigo"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check4}
                        onChange={handleCheckAir}
                        name="I5"
                      />
                    }
                    label="Air Asia"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check5}
                        onChange={handleCheckVistara}
                        name="UK"
                      />
                    }
                    label="Vistara"
                  />
                  <br />
                </Box> */}
              <Divider style={{ marginTop: 20 }} />
              <h4>Departure Time:</h4>
              {/* <Box display="flex" mt={matches ? "20px" : ""}>
                  <Box
                    onClick={() => {
                      handlemorning();
                      morning ? setMorning(false) : setMorning(true);
                      rule ? SetRule(false) : SetRule(true);
                    }}
                    style={{
                      display: "block",
                      padding: "6px 10px",
                      textAlign: "center",
                      background: morning ? "rgb(239, 51, 57)" : "#8f8f8f",
                      color: morning ? "white" : "",
                      borderRight: "1px solid #ddd",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    <WbSunnyIcon />
                    <Box>
                      <BodyText one textStyle={{ color: "white" }}>
                        05-12
                      </BodyText>
                    </Box>
                  </Box>
                  <Box
                    onClick={() => {
                      handledophar();
                      dophar ? setDOphar(false) : setDOphar(true);
                      rule ? SetRule(false) : SetRule(true);
                    }}
                    ml={"10px"}
                    style={{
                      display: "block",
                      padding: "6px 10px",
                      textAlign: "center",
                      borderRight: "1px solid #ddd",
                      fontWeight: 700,
                      cursor: "pointer",
                      background: dophar ? "rgb(239, 51, 57)" : "#8f8f8f",
                      color: dophar ? "white" : "",
                    }}
                  >
                    <WbSunnyIcon />
                    <Box>
                      <BodyText one textStyle={{ color: "white" }}>
                        12-18
                      </BodyText>
                    </Box>
                  </Box>
                </Box> */}
            </Box>
          </Grid>
          <Grid item xs={10}>
            <h3>{`Flights from ${selectedOrigin.city_name} to ${
              selectedDepart.city_name
            }(${5})`}</h3>
            {loading ? (
              <>
                {[0, 1, 2, 3, 4, 5, 6].map((i) => {
                  return <SkeletonOneway />;
                })}
              </>
            ) : (
              <InfiniteScroll
                dataLength={scrollValResult}
                next={fetchMoreDataResult}
                hasMore={hasMoreresult}
                loader={<h4>Loading...</h4>}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>No More Data</b>
                  </p>
                }
              >
                {flightreturn &&
                  flightreturn.result &&
                  flightreturn.result.Response &&
                  flightreturn.result.Response.Results[0].map((item, index) => {
                    return index < scrollValResult ? (
                      <>
                        <Accordion
                          style={{ marginTop: 10 }}
                          expanded={expanded === `panel${index + 1}`}
                          onChange={handleChange(`panel${index + 1}`)}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box style={{ display: "flex" }}>
                                    <img
                                      width="50px"
                                      height="50px"
                                      src={`https://nitish.musafirbazar.com/static/media/${item.Segments[0]
                                        .slice(0, 1)
                                        .map((i) => {
                                          return i.Airline.AirlineCode;
                                        })}.gif`}
                                    />
                                    <Box ml={"10px"}>
                                      <span>
                                        {item.Segments[0]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineName;
                                          })}
                                      </span>
                                      <br></br>
                                      <span>
                                        {item.Segments[0]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineCode;
                                          })}
                                      </span>
                                    </Box>
                                  </Box>
                                  <Box>
                                    <Box display="flex">
                                      <span style={{ fontWeight: "bold" }}>
                                        {item.Origin
                                          ? item.Origin
                                          : item.FareRules[0].Origin}
                                      </span>
                                      <span
                                        style={{
                                          marginLeft: 5,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        -
                                      </span>
                                      <span
                                        style={{
                                          marginLeft: 5,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {" "}
                                        {item.Airline_Code
                                          ? item.Segments.length === 1
                                            ? item.Segments.filter(
                                                (i, index) => index === 0
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : item.Segments.length === 2
                                            ? item.Segments.filter(
                                                (i, index) => index === 1
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : item.Segments.length === 3
                                            ? item.Segments.filter(
                                                (i, index) => index === 2
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : ""
                                          : item.Segments[0].length == 2
                                          ? item.Segments[0]
                                              .filter((i, index) => index === 1)
                                              .map((it) => {
                                                return it.Destination.Airport
                                                  .AirportCode;
                                              })
                                          : item.Segments[0].length == 3
                                          ? item.Segments[0]
                                              .filter((i, index) => index === 2)
                                              .map((it) => {
                                                return it.Destination.Airport
                                                  .AirportCode;
                                              })
                                          : item.Segments[0].length == 1
                                          ? item.Segments[0].map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                          : ""}
                                      </span>
                                      {/* <br></br> */}
                                    </Box>
                                    <br></br>
                                    <span
                                      style={{ fontSize: 16, fontWeight: 600 }}
                                    >
                                      {item.Airline_Code
                                        ? item.Segments[0].Departure_DateTime.substr(
                                            11,
                                            5
                                          )
                                        : item.AirlineCode
                                        ? item.Segments[0]
                                            .slice(0, 1)
                                            .map((i) => {
                                              return i.Origin.DepTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : ""}
                                        {/* {item.Segments[0].slice} */}
                                    </span>
                                    <span style={{ fontSize: 16, fontWeight: 600 }}>-</span>
                                    <span style={{ fontSize: 16, fontWeight: 600 }} >{item.Airline_Code
								? item.Segments.length === 1
									? item.Segments.filter((i, index) => index === 0).map(
											(it) => {
												return it.Departure_DateTime.substr(11, 5);
											}
									  )
									: item.Segments.length === 2
									? item.Segments.filter((i, index) => index === 1).map(
											(it) => {
												return it.Departure_DateTime.substr(11, 5);
											}
									  )
									: item.Segments.length === 3
									? item.Segments.filter((i, index) => index === 2).map(
											(it) => {
												return it.Departure_DateTime.substr(11, 5);
											}
									  )
									: ''
								: item.AirlineCode
								? item.Segments[0].length == 3
									? item.Segments[0]
											.filter((i, index) => index === 2)
											.map((i) => {
												return i.Destination.ArrTime.substr(11, 5);
											})
									: item.Segments[0].length == 2
									? item.Segments[0]
											.filter((i, index) => index === 1)
											.map((i) => {
												return i.Destination.ArrTime.substr(11, 5);
											})
									: item.Segments[0].length == 1
									? item.Segments[0]
											.filter((i, index) => index === 0)
											.map((i) => {
												return i.Destination.ArrTime.substr(11, 5);
											})
									: ''
								: ''}</span>
                                  </Box>

                                  <Box
                                    style={{ display: "flex" }}
                                    onClick={() =>
                                      data ? setData(false) : setData(true)
                                    }
                                  >
                                    <img
                                      width="50px"
                                      height="50px"
                                      src={`https://nitish.musafirbazar.com/static/media/${item.Segments[1]
                                        .slice(0, 1)
                                        .map((i) => {
                                          return i.Airline.AirlineCode;
                                        })}.gif`}
                                    />
                                    <Box ml={"10px"}>
                                      <span>
                                        {item.Segments[1]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineName;
                                          })}
                                      </span>
                                      <br></br>
                                      <span>
                                        {item.Segments[1]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineCode;
                                          })}
                                      </span>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                              <Grid item xs={6}>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box display="flex">
                                    <span style={{ fontWeight: "bold" }}>
                                      {item.Segments[1]
                                        .slice(0, 1)
                                        .map((it) => {
                                          return it.Origin.Airport.AirportCode;
                                        })}
                                    </span>
                                    <span
                                      style={{
                                        marginLeft: 5,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      -
                                    </span>
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        marginLeft: 5,
                                      }}
                                    >
                                      {" "}
                                      {item.Airline_Code
                                        ? item.Segments.length === 1
                                          ? item.Segments.filter(
                                              (i, index) => index === 0
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 2
                                          ? item.Segments.filter(
                                              (i, index) => index === 1
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 3
                                          ? item.Segments.filter(
                                              (i, index) => index === 2
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : ""
                                        : item.Segments[1].length == 2
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 1)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[1].length == 3
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 2)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[1].length == 1
                                        ? item.Segments[1].map((it) => {
                                            return it.Destination.Airport
                                              .AirportCode;
                                          })
                                        : ""}
                                    </span>
                                  </Box>
                                  <Box>
                                  <br></br>
                                    <span
                                      style={{ fontSize: 16, fontWeight: 600 }}
                                    >
                                      {item.Airline_Code
                                        ? item.Segments[1].Departure_DateTime.substr(
                                            11,
                                            5
                                          )
                                        : item.AirlineCode
                                        ? item.Segments[1]
                                            .slice(0, 1)
                                            .map((i) => {
                                              return i.Origin.DepTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : ""}
                                        {/* {item.Segments[0].slice} */}
                                    </span>
                                    <span style={{ fontSize: 16, fontWeight: 600 }}>-</span>
                                    <span style={{ fontSize: 16, fontWeight: 600 }} >{item.Airline_Code
								? item.Segments.length === 1
									? item.Segments.filter((i, index) => index === 0).map(
											(it) => {
												return it.Departure_DateTime.substr(11, 5);
											}
									  )
									: item.Segments.length === 2
									? item.Segments.filter((i, index) => index === 1).map(
											(it) => {
												return it.Departure_DateTime.substr(11, 5);
											}
									  )
									: item.Segments.length === 3
									? item.Segments.filter((i, index) => index === 2).map(
											(it) => {
												return it.Departure_DateTime.substr(11, 5);
											}
									  )
									: ''
								: item.AirlineCode
								? item.Segments[1].length == 3
									? item.Segments[1]
											.filter((i, index) => index === 2)
											.map((i) => {
												return i.Destination.ArrTime.substr(11, 5);
											})
									: item.Segments[1].length == 2
									? item.Segments[1]
											.filter((i, index) => index === 1)
											.map((i) => {
												return i.Destination.ArrTime.substr(11, 5);
											})
									: item.Segments[1].length == 1
									? item.Segments[1]
											.filter((i, index) => index === 0)
											.map((i) => {
												return i.Destination.ArrTime.substr(11, 5);
											})
									: ''
								: ''}</span>
                                  </Box>

                                  <Box display="flex">
                                    <h3>
                                      ₹ {Math.round(item.Fare.Total_Amount)}
                                    </h3>
                                    <Box
                                      onClick={() => {
                                        history.push({
                                          pathname: "/summaryflight",
                                          state: {
                                            orderID: orderID?.result,
                                            // flightData:
                                            //   resultSelection.length == 1
                                            //     ? resultSelection
                                            //     : onward.length == 1
                                            //     ? onward
                                            //     : "",
                                            // selectedonward:
                                            //   selectedonward.length == 1
                                            //     ? selectedonward
                                            //     : "",
                                            // selectedReturn:
                                            //   selectedReturn.length == 1
                                            //     ? selectedReturn
                                            //     : "",

                                            // Returnflight:
                                            //   resultRSelection.length == 1
                                            //     ? resultRSelection
                                            //     : returnD.length == 1
                                            //     ? returnD
                                            //     : "",
                                            returnBody:
                                              location.state.returnBody,
                                            intFlight: item,
                                            // ID:
                                            //   flightreturn &&
                                            //   flightreturn.result &&
                                            //   flightreturn.result.Response &&
                                            //   flightreturn.result.Response.TraceId,
                                            IDTBO:
                                              flightreturn &&
                                              flightreturn.result &&
                                              flightreturn.result.Response &&
                                              flightreturn.result.Response
                                                .TraceId,
                                            // IDEtrav:
                                            //   roundTripEtrav &&
                                            //   roundTripEtrav.result &&
                                            //   roundTripEtrav.result.Search_Key,
                                          },
                                        });
                                      }}
                                      textAlign="center"
                                      style={{
                                        marginLeft: 20,
                                        background: "#ef631e",
                                        color: "white",
                                        borderRadius: "5px",
                                        padding: "0px 10px",
                                      }}
                                    >
                                      <h3>Book Now</h3>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                {" "}
                                <Box style={{ marginTop: 25 }}>
                                  <span>Depart</span>
                                </Box>
                                <Box
                                  style={{
                                    padding: 10,
                                    border: "1px solid #ebe5e5",
                                  }}
                                >
                                  {item.Segments[0].map((i) => {
                                    return (
                                      <>
                                        <Box
                                          display="flex"
                                          style={{ marginTop: 10 }}
                                          justifyContent="space-between"
                                        >
                                          {" "}
                                          <Box>
                                            <span>
                                              {i.Origin.Airport.AirportCode}
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Origin.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Origin.DepTime.substr(11, 5)}
                                            </span>
                                          </Box>
                                          <Box style={{ textAlign: "center" }}>
                                            <span>
                                              {timeConvert(i.Duration)}
                                            </span>
                                            <div className="ln"></div>
                                            <br></br>
                                            <span style={{ marginLeft: 5 }}>
                                              Non Stop
                                            </span>
                                          </Box>
                                          <Box>
                                            <span>
                                              {
                                                i.Destination.Airport
                                                  .AirportCode
                                              }
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Destination.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              )}
                                            </span>
                                          </Box>
                                        </Box>
                                      </>
                                    );
                                  })}
                                </Box>
                              </Grid>
                              <Grid item xs={6}>
                                {" "}
                                <Box style={{ marginTop: 20 }}>
                                  <span>Return</span>
                                </Box>
                                <Box
                                  style={{
                                    padding: 10,
                                    border: "1px solid #ebe5e5",
                                  }}
                                >
                                  {item.Segments[1].map((i) => {
                                    return (
                                      <>
                                        <Box
                                          display="flex"
                                          style={{ marginTop: 10 }}
                                          justifyContent="space-between"
                                        >
                                          {" "}
                                          <Box>
                                            <span>
                                              {i.Origin.Airport.AirportCode}
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Origin.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Origin.DepTime.substr(11, 5)}
                                            </span>
                                          </Box>
                                          <Box style={{ textAlign: "center" }}>
                                            <span>
                                              {timeConvert(i.Duration)}
                                            </span>
                                            <div className="ln"></div>
                                            <br></br>
                                            <span style={{ marginLeft: 5 }}>
                                              Non Stop
                                            </span>
                                          </Box>
                                          <Box>
                                            <span>
                                              {
                                                i.Destination.Airport
                                                  .AirportCode
                                              }
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Destination.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              )}
                                            </span>
                                          </Box>
                                        </Box>
                                      </>
                                    );
                                  })}
                                </Box>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    ) : (
                      ""
                    );
                  })}
              </InfiniteScroll>
            )}
          </Grid>
        </Grid>
      </Box>
      {/* </Container> */}
    </>
  );
};

export default International;
